const SDK_URL = "https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js";
const REFRESH_INTERVAL = 6000;

let sdkPromise;
// SDK 自身会缓存广告位配置；保留同一注册对象，切页回来时更新回调并重新拉取。
const banners = new Map();
const getBannerKey = (placementId, containerId) => `${placementId}:${containerId}`;

function loadSdk() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return Promise.resolve(false);
  }
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = SDK_URL;
    script.onload = () => resolve(true);
    script.onerror = (error) => {
      sdkPromise = undefined;
      script.remove();
      reject(error);
    };
    document.head.appendChild(script);
  });
  return sdkPromise;
}

const getActiveContainer = (banner) => banner.mounted
  && document.getElementById(banner.containerId);

function scheduleRefresh(banner) {
  window.clearTimeout(banner.refreshTimer);
  banner.refreshTimer = window.setTimeout(() => {
    banner.refreshTimer = undefined;
    const container = getActiveContainer(banner);
    // SDK 自带的关闭按钮会把容器高度设为 0；关闭后不再轮播。
    if (!container || container.style.height === "0px") return;
    if (document.hidden) {
      scheduleRefresh(banner);
      return;
    }
    requestBanner(banner);
  }, REFRESH_INTERVAL);
}

function requestBanner(banner) {
  const container = getActiveContainer(banner);
  const native = window.TencentGDT?.NATIVE;
  if (!container || banner.pending || typeof native?.loadAd !== "function") return;
  banner.pending = true;
  try {
    native.loadAd(banner.placementId);
  } catch (error) {
    banner.pending = false;
    banner.onComplete?.({ ret: -1, message: error?.message || "广告加载失败" });
  }
}

/** 注册横幅广告，共用 SDK，但分别维护广告位的容器、回调和轮播生命周期。 */
export function mountBannerAd({ appId, placementId, containerId, onComplete }) {
  if (typeof window === "undefined" || !appId || !placementId || !containerId) {
    return Promise.resolve(false);
  }
  window.TencentGDT = window.TencentGDT || [];
  const key = getBannerKey(placementId, containerId);
  let banner = banners.get(key);
  const returning = Boolean(banner);
  const reloadOnReady = returning && !banner.mounted && banner.initialized && !banner.pending;
  if (!banner) {
    banner = { placementId, containerId, mounted: false, pending: true, initialized: false, version: 0 };
    banners.set(key, banner);
  }
  banner.mounted = true;
  banner.onComplete = onComplete;
  const version = ++banner.version;

  if (!returning) {
    window.TencentGDT.push({
      app_id: appId,
      placement_id: placementId,
      type: "native",
      display_type: "banner",
      // 由页面控制 6 秒轮播，确保离开路由后停止请求，不留下 SDK 内部轮播任务。
      carousel: 0,
      containerid: containerId,
      onComplete: (res) => {
        banner.initialized = true;
        banner.pending = false;
        if (!getActiveContainer(banner)) return;
        banner.onComplete?.(res);
        if (Number(res?.ret) === 0) scheduleRefresh(banner);
      },
    });
  }

  return loadSdk().then((loaded) => {
    if (loaded && reloadOnReady && banner.version === version) {
      requestBanner(banner);
    }
    return loaded;
  });
}

/** 停止该页面的轮播并断开组件回调，保留 SDK 已注册的配置供再次进入使用。 */
export function unmountBannerAd({ placementId, containerId }) {
  if (typeof window === "undefined") return;
  const banner = banners.get(getBannerKey(placementId, containerId));
  if (!banner) return;
  banner.mounted = false;
  banner.onComplete = undefined;
  window.clearTimeout(banner.refreshTimer);
  banner.refreshTimer = undefined;
}

export { SDK_URL };
